export default __webpack_public_path__ + "static/media/mailAnimation.e97cfb52.gif";